
import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api from "../../../api/Api.js";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Search } from "lucide-react";
import Swal from "sweetalert2";

const CountryManage = () => {
  const urlLink = "https://www.patratravels.com/holidays/";
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [Countrys, setCountrys] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [getState, setState] = useState([]);

  // =========================
  // FETCH CITY DATA
  // =========================
  const fetchCountryData = async () => {
    try {
      const res = await api.get(
        "/adminHolidays/get-holidays-city-data"
      );

      setCountrys(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load city Name data");
    }
  };

  // =========================
  // FETCH STATE DATA
  // =========================
  const fetchStateData = async () => {
    try {
      const res = await api.get(
        "/adminHolidays/get-holidays-state-data"
      );

      const stateData = res.data?.data;

      setState(Array.isArray(stateData) ? stateData : []);
    } catch (error) {
      toast.error("Failed to load State Name data");
      setState([]);
    }
  };

  useEffect(() => {
    fetchCountryData();
    fetchStateData();
  }, []);

  // =========================
  // GET STATE NAME BY STATE ID
  // =========================
  const getStateName = (stateId) => {
    const matchedState = getState.find(
      (state) =>
        String(state.state_id) === String(stateId)
    );

    return matchedState?.state || "State Not Found";
  };

  // =========================
  // DELETE CITY
  // =========================
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete City Name?",
      text: "Do you want to delete this City Name?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes Delete",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await api.delete(
        `/adminHolidays/holidays-city-delete/${id}`
      );

      if (res.data.success) {
        Swal.fire(
          "Deleted!",
          "City Name deleted successfully",
          "success"
        );

        fetchCountryData();
      }
    } catch (error) {
      toast.error("Failed to delete City Name");
    }
  };

  // =========================
  // STATUS CHANGE
  // =========================
  const handleStatusChange = async (id, is_active) => {
    try {
      await api.put(
        "/adminHolidays/holidays-city-status",
        {
          id,
          is_active,
        }
      );

      toast.success("Status updated");
      fetchCountryData();
    } catch (error) {
      toast.error("Failed to update status");
    }
  };

  // =========================
  // EDIT CITY
  // =========================
  const handleEditCountry = (cityId) => {
    navigate(`/holidays/city/edit-city/${cityId}`);
  };

  // =========================
  // FILTER & SEARCH
  // =========================
  const filteredCountries = Countrys.filter((cat) => {
    const term = searchTerm.trim().toLowerCase();

    const cityName = String(cat.city || "").toLowerCase();
    const citySlug = String(cat.slug || "").toLowerCase();
    const stateName = String(
      getStateName(cat.state_id)
    ).toLowerCase();

    return (
      cityName.includes(term) ||
      citySlug.includes(term) ||
      stateName.includes(term)
    );
  });

  // =========================
  // PAGINATION
  // =========================
  const totalPages = Math.ceil(
    filteredCountries.length / perPage
  );

  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;

  const currentItems = filteredCountries.slice(
    indexOfFirst,
    indexOfLast
  );

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  // =========================
  // JSX
  // =========================
  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
        <div className="card-body d-flex justify-content-between align-items-center flex-wrap gap-3">

          <h4 className="fw-bold mb-0">
            Manage Holidays City Name
          </h4>

          <div className="d-flex align-items-center flex-wrap gap-2">

            <div
              className="input-group input-group-sm"
              style={{ width: "200px" }}
            >
              <span className="input-group-text bg-white">
                <Search size={16} />
              </span>

              <input
                type="text"
                className="form-control"
                placeholder="Search city, state, slug..."
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>

            <Link
              to="/holidays/city/add-city"
              className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
            >
              <ArrowLeft size={16} />
              Add Holidays City Name
            </Link>

          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="card shadow-sm border-0">
        <div className="table-responsive">

          <table className="table table-hover table-sm align-middle mb-0">

            <thead className="bg-light">
              <tr>
                <th>Sl</th>
                <th>State Name</th>
                <th>City Name</th>
                <th>Slug</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {currentItems.length === 0 ? (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center py-4 text-muted"
                  >
                    No City Name Found
                  </td>
                </tr>
              ) : (
                currentItems.map((cat, index) => (
                  <tr key={cat.city_id}>

                    <td>
                      {indexOfFirst + index + 1}
                    </td>

                    {/* STATE NAME */}
                    <td>
                      {getStateName(cat.state_id)}
                    </td>

                    {/* CITY NAME */}
                    <td>{cat.city}</td>

                    {/* SLUG */}
                    <td>{cat.slug}</td>

                    {/* STATUS */}
                    <td>
                      {!cat.meta_title ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "14px",
                          }}
                        >
                          Update Country SEO Details
                        </span>
                      ) : (
                        <select
                          className={`form-select form-select-sm ${
                            cat.is_active == 1
                              ? "text-success"
                              : "text-danger"
                          }`}
                          value={String(cat.is_active)}
                          onChange={(e) =>
                            handleStatusChange(
                              cat.city_id,
                              e.target.value
                            )
                          }
                        >
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      )}
                    </td>

                    {/* ACTION */}
                    <td>
                      <button
                        type="button"
                        className="btn btn-sm btn-primary me-2"
                        onClick={() =>
                          handleEditCountry(cat.city_id)
                        }
                      >
                        <i className="fa fa-pencil"></i>
                      </button>

                      <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={() =>
                          handleDelete(cat.city_id)
                        }
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>

                  </tr>
                ))
              )}
            </tbody>

          </table>
        </div>

        {/* PAGINATION */}
        {totalPages > 0 && (
          <div className="d-flex justify-content-center mt-3">
            <ul className="pagination">

              <li
                className={`page-item ${
                  currentPage === 1 ? "disabled" : ""
                }`}
              >
                <button
                  type="button"
                  className="page-link"
                  disabled={currentPage === 1}
                  onClick={() =>
                    setCurrentPage((prev) => prev - 1)
                  }
                >
                  Prev
                </button>
              </li>

              {Array.from(
                { length: totalPages },
                (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                )
              )}

              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  type="button"
                  className="page-link"
                  disabled={currentPage === totalPages}
                  onClick={() =>
                    setCurrentPage((prev) => prev + 1)
                  }
                >
                  Next
                </button>
              </li>

            </ul>
          </div>
        )}

      </div>
    </div>
  );
};

export default CountryManage;
